export default "__VITE_ASSET__e846df54__"